import React, { useContext, useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import useApi from 'common/useApi';
import auth from 'common/auth';
import UiContext from 'common/UiContext/UiContext';
import useFormApiErrors from 'common/useFormApiErrors';

import LoginCard from 'components/LoginCard';
import InputPassword from 'components/InputPassword';
import InputEmail from 'components/InputEmail';
import FormLabel from 'components/FormLabel';

const SignUp = () => {
  const navigate = useNavigate();
  const { addToast } = useContext(UiContext);
  const { setTempToken } = useContext(auth)!;
  const { isError, error, isLoading, mutate, isSuccess } = useApi('post', '/api/signup');
  const formMethods = useForm({ mode: 'onChange' });

  const { handleSubmit, register, setError, formState: { isSubmitting, isDirty, isValid } } = formMethods;

  const onSubmit = ({ username, password, email, password_confirm }: Record<string, string>) => {
    mutate({
      email,
      password,
      password_confirm,
      username,
    });
  };

  useFormApiErrors(isError, error, setError);

  useEffect(() => {
    if(isSuccess){
      // S9: signup now establishes a session (no token returned). Flag that the
      // user just signed up so the verification-required page is reachable.
      setTempToken('signed-up');
      addToast!('Verification email sent. Please check your inbox.');
      navigate('/verification-required');
    }
  }, [isSuccess]);

  return (
    <LoginCard title='Sign Up' create={false}>
      <FormProvider {...formMethods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormLabel field='username' name='Name'>
            <input
              {...register('username', { required: 'Account Name is required' })}
              type='text'
              placeholder='Account Name'
            />
          </FormLabel>
          <InputEmail field='email' name='Email Address' />
          <InputPassword name='password' />
          <InputPassword
            name='password_confirm'
            placeholder='Repeat your Password'
            title='Repeat your Password'
            match='password'
          />
          <button
            className='primary big'
            disabled={isLoading || isSubmitting || (!isValid && isDirty)}
          >
            Sign Up
          </button>
        </form>
      </FormProvider>
    </LoginCard>
  );
};

export default SignUp;